 
import parsePhoneNumber from 'libphonenumber-js';

const formatPhone = (phone: string) => {
  let result = '';

  if (phone) {
    const phoneNumber = parsePhoneNumber(phone);

    if (phoneNumber) {
      const code = phoneNumber.countryCallingCode;

      const formatted = phone.replace('+', '').replace(code, '');

      if (formatted.charAt(0) === '0') {
        result = `+${code} ${phoneNumber.formatNational()}`;
      } else {
        result = phoneNumber.formatInternational();
      }
    }
  }

  return result;
};

export default formatPhone;
